import { FoundationsAlertType } from '../Types/FoundationsTypes'
function FoundationsAlert(props: FoundationsAlertType) {
    return (
        <>
            <div className={`status-box-${props.type} mb-3 text-left ${props.classes}`}>
                {props.message}
            </div>
        </>
    )
}

export { FoundationsAlert }
